<template>
  <app-logged id="EstadosCreate">
    <v-flex xs12>
      <validation-observer
        ref="observer"
        v-slot="{ invalid }"
        tag="form"
      >
        <v-form>
          <app-widget
            actions
            class-widget="md6 offset-md3 sm8 offset-sm2 xs12"
          >
            <div slot="widget-content">
              <validation-provider
                name="nome"
                rules="required|alpha_spaces"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="estado.nome"
                  label="Nome"
                  outlined
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                name="acrônimo"
                rules="required|alpha|max:2"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="estado.acronimo"
                  label="Acrônimo"
                  outlined
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
            </div>
            <div slot="widget-actions">
              <v-spacer />
              <app-button
                v-if="estado.id"
                @click.native="remove"
                color="error"
                class="mr-2"
              >
                remover
              </app-button>
              <app-button
                @click.native.prevent="save()"
                :disable="invalid"
              >
                salvar
              </app-button>
            </div>
          </app-widget>
        </v-form>
      </validation-observer>
    </v-flex>
  </app-logged>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import AppLogged from '@/components/layouts/AppLogged'
import AppWidget from '@/components/AppWidget'
import AppButton from '@/components/AppButton'
export default {
  name: 'EstadosCreate',
  components: {
    AppWidget,
    AppLogged,
    ValidationProvider,
    ValidationObserver,
    AppButton
  },
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['estado'])
  },
  methods: {
    ...mapActions(['postSaveEstado', 'deleteEstado']),
    goToEstadoIndex () {
      this.$router.push({
        name: 'estados-index'
      })
    },
    remove () {
      if (confirm('Confirme a exclusão deste estado.')) {
        this.deleteEstado().then(res => {
          this.goToEstadoIndex()
        })
      }
    },
    save () {
      this.$refs.observer.validate().then(result => {
        if (result) {
          this.postSaveEstado().then(res => {
            this.goToEstadoIndex()
          })
        }
      })
    }
  },
  mounted () {}
}
</script>
